// GET CLIENT LIST
export const CLIENT_DATA = "CLIENT_DATA"
export const CLIENT_DATA_SUCCESS = "CLIENT_DATA_SUCCESS"
export const ALL_CLIENT_DATA_SUCCESS = "ALL_CLIENT_DATA_SUCCESS"
export const CLIENT_DATA_ERROR = "CLIENT_DATA_ERROR"
export const CLIENT_DROPDOWN_FETCH = "CLIENT_DROPDOWN_FETCH"
export const CLIENT_DROP = "CLIENT_DROP"

// ADD NEW CLIENT
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT"
export const ADD_NEW_CLIENT_SUCCESS = "ADD_NEW_CLIENT_SUCCESS"
export const ADD_NEW_CLIENT_ERROR = "ADD_NEW_CLIENT_ERROR"
// ADD NEW CLIENT
export const UPDATE_NEW_CLIENT = "UPDATE_NEW_CLIENT"
export const UPDATE_NEW_CLIENT_SUCCESS = "UPDATE_NEW_CLIENT_SUCCESS"
export const UPDATE_NEW_CLIENT_ERROR = "UPDATE_NEW_CLIENT_ERROR"
//DELETE CLENT 
export const DELETE_CLIENT_BYID = "DELETE_CLIENT_BYID"
export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS"
export const DELETE_CLIENT_ERROR = "DELETE_CLIENT_ERROR"
//BULK UPLOAD
export const BULK_UPLOAD = "BULK_UPLOAD"
export const BULK_UPLOAD_SUCCESS = "BULK_UPLOAD_SUCCESS"
export const BULK_UPLOAD_ERROR = "BULK_UPLOAD_ERROR"

